import React, { useCallback, useContext, useEffect, useState } from 'react'
import DescricaoDoProjetoOuInvestimento from './DescricaoDoProjetoOuInvestimento'
import MotivadorDoCapexNaoPrevisto from './MotivadorDoCapexNaoPrevisto'
import Orcamento from './Orcamento'
import RecursosParaExecucao from './RecursosParaExecucao'
import Detalhes from './Detalhes'
import ValidacoesAprovacoes from './ValidacoesAprovacoes'
import { useRecoilValue } from 'recoil'
import { aprovacoesSolicitacaoState, solicitacaoIdState } from '../../../atoms'
import { Visibility } from '@app/components/Visibility'
import { FormContext, notification } from '@digital/ui'
import { isObjNotEmpty } from '@app/helpers/objHelper'
import OrcamentoFinanceiro from './OrcamentoFinanceiro'
import { getOrcamentoSolicitacaoNaoPrevisto, OrcamentoSolicitacaoNaoPrevisto } from '@app/api/naoPrevistos/orcamentoSolicitacao'
import { getAllAcronimosPacote } from '@app/api/acronimosPacote'
import { getAllCrfContaContabil } from '@app/api/crf/contaContabil'
import { Collapse, Icon } from 'antd'
import ptBR from '@app/i18n/ptBR'

const { Panel } = Collapse

const PANEL_SOLICITANTE = 'solicitante'
const PANEL_PROJETO = 'projeto'
const PANEL_DETALHES = 'detalhes'
const PANEL_ORCAMENTO_ECONOMICO = 'orcamentoEconomico'
const PANEL_ORCAMENTO_FINANCEIRO = 'orcamentoFinanceiro'
const PANEL_RECURSOS = 'recursos'

const CAMPOS_PANEL_DETALHES = ['forecastDoMes', 'naoPrevistosAprovados', 'impactoNoForecast', 'forecastAtualizado', 'impactoNoForecastFinanceiro', 'forecastAtualizadoFinanceiro']
const CAMPOS_PANEL_SOLICITANTE = ['adUserResponsavel', 'nomeProjeto', 'escopo', 'vidaUtilEmMeses', 'porQueAgora', 'tipoNaoPrevistoId', 'observacao']

interface IStepPreenchimentoTipoSolicitacaoProps {
}

const StepPreenchimentoTipoSolicitacao = ({ }: IStepPreenchimentoTipoSolicitacaoProps) => {
  const { formProps } = useContext(FormContext);
  const aprovacoesSolicitacao = useRecoilValue(aprovacoesSolicitacaoState);
  const idSolicitacao = useRecoilValue(solicitacaoIdState);
  const [activeCollapseKeys, setActiveCollapseKeys] = useState<string[]>([PANEL_SOLICITANTE]);
  const [list, setList] = useState<OrcamentoSolicitacaoNaoPrevisto[]>([])
  const [orcamentos, setOrcamentos] = useState<OrcamentoSolicitacaoNaoPrevisto[]>([])
  const [acronimos, setAcronimos] = useState([])
  const [contasContabil, setContasContabil] = useState([])
  const [orcamentoDataLoaded, setOrcamentoDataLoaded] = useState(false);

  const loadOrcamentoData = useCallback(() => {
    if (orcamentoDataLoaded || idSolicitacao === undefined) return;
    setOrcamentoDataLoaded(true);
    getOrcamentoSolicitacaoNaoPrevisto(idSolicitacao).then((response) => {
      if (response) {
        const newOrcamentoList = response.map((item) => ({ ...item }));
        setList([...response]);
        setOrcamentos(newOrcamentoList);
      }
    });
    getAllAcronimosPacote().then((response) => {
      if (response) setAcronimos(response);
    });
    getAllCrfContaContabil().then((response) => {
      if (response) setContasContabil(response);
    });
  }, [idSolicitacao, orcamentoDataLoaded]);

  useEffect(() => {
    if (idSolicitacao !== undefined) loadOrcamentoData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idSolicitacao]);

  useEffect(() => {
    const needsOrcamento = activeCollapseKeys.indexOf(PANEL_ORCAMENTO_ECONOMICO) >= 0 || activeCollapseKeys.indexOf(PANEL_ORCAMENTO_FINANCEIRO) >= 0;
    if (needsOrcamento) loadOrcamentoData();
  }, [activeCollapseKeys, loadOrcamentoData]);

  useEffect(() => {
    if (formProps && formProps.isValidating && formProps.errors && isObjNotEmpty(formProps.errors)) {
      notification.info('Existem campos obrigatórios não preenchidos.', '');
      const keysWithErrors = Object.keys(formProps.errors);
      setActiveCollapseKeys((prev) => {
        const next = new Set(prev);
        if (keysWithErrors.some((k) => CAMPOS_PANEL_DETALHES.includes(k))) next.add(PANEL_DETALHES);
        if (keysWithErrors.some((k) => CAMPOS_PANEL_SOLICITANTE.includes(k))) next.add(PANEL_SOLICITANTE);
        return Array.from(next);
      });
    }
  }, [formProps?.errors, formProps?.isValidating]);

  return (
    <div spellCheck={true}>
      <Collapse
        bordered={false}
        activeKey={activeCollapseKeys}
        onChange={(keys) => setActiveCollapseKeys(Array.isArray(keys) ? keys : [keys])}
        expandIcon={() => <Icon type="arrows-right_4" />}
      >
        <Panel key={PANEL_SOLICITANTE} header={ptBR.lblSolicitante} style={{ border: 0 }}>
          <DescricaoDoProjetoOuInvestimento noCollapse />
        </Panel>
        <Panel key={PANEL_PROJETO} header={ptBR.lblProjeto} style={{ border: 0 }}>
          {activeCollapseKeys.indexOf(PANEL_PROJETO) >= 0 ? <MotivadorDoCapexNaoPrevisto noCollapse /> : null}
        </Panel>
        <Panel key={PANEL_DETALHES} header={ptBR.lblDetalhes} style={{ border: 0 }}>
          {activeCollapseKeys.indexOf(PANEL_DETALHES) >= 0 ? <Detalhes noCollapse /> : null}
        </Panel>
        <Panel key={PANEL_ORCAMENTO_ECONOMICO} header={ptBR.lblOrcamento} style={{ border: 0 }}>
          {activeCollapseKeys.indexOf(PANEL_ORCAMENTO_ECONOMICO) >= 0 ? (
            <Orcamento list={list} setList={setList} orcamentos={orcamentos} setOrcamentos={setOrcamentos} acronimos={acronimos} contasContabil={contasContabil} noCollapse />
          ) : null}
        </Panel>
        <Panel key={PANEL_ORCAMENTO_FINANCEIRO} header={ptBR.lblOrcamentoFinanceiro} style={{ border: 0 }}>
          {activeCollapseKeys.indexOf(PANEL_ORCAMENTO_FINANCEIRO) >= 0 ? (
            <OrcamentoFinanceiro list={list} setList={setList} orcamentos={orcamentos} setOrcamentos={setOrcamentos} acronimos={acronimos} contasContabil={contasContabil} noCollapse />
          ) : null}
        </Panel>
        <Panel key={PANEL_RECURSOS} header={ptBR.lblRecursosParaExecucaoEconomiasEmOutrosProjetos} style={{ border: 0 }}>
          {activeCollapseKeys.indexOf(PANEL_RECURSOS) >= 0 ? <RecursosParaExecucao noCollapse /> : null}
        </Panel>
      </Collapse>

      <Visibility visible={aprovacoesSolicitacao.length > 0} >
        <ValidacoesAprovacoes />
      </Visibility>
    </div>
  )
}

export default StepPreenchimentoTipoSolicitacao